import React, { useMemo } from 'react';
// @ts-ignore
import styles from './StarInput.module.scss';
import { joinClasses } from '../../../../../../Utils/className.util';

interface Props {
	name: string;
	ratingRange: number;
	onChange: (stars: number) => void;
	value?: number;
}

const StarInput: React.FC<Props> = ({
	name,
	ratingRange,
	onChange,
	value = 0,
}) => {
	const starts = useMemo(() => {
		const starts: { value: number; active: boolean }[] = [];
		for (let i = 1; i < ratingRange + 1; i++) {
			starts.push({ value: i, active: i <= value });
		}
		return starts;
	}, [ratingRange, value]);

	const handleChange = (value: number) => {
		onChange(value);
	};

	return (
		<>
			<div className={styles.wrapper}>
				{starts.map(item => (
					<div
						key={item.value}
						className={styles.star}
						onClick={() => handleChange(item.value)}
					>
						<img
							className={styles.icon}
							alt='star icon'
							src={
								item.active
									? '/dist/icons/star-solid-active.svg'
									: '/dist/icons/star-solid-inactive.svg'
							}
						/>
					</div>
				))}
			</div>
			<input type='number' value={value} className='d-none' name={name} />
		</>
	);
};

export default StarInput;
